/* eslint-disable camelcase */
import { useMemo } from 'react';
import type Decimal from 'decimal.js';

import { prettifyPriceWithCurrencySymbol } from '@hotjar/webapp/billing/cost';

import { useOwnedAccountCurrency } from './useOwnedAccountCurrency';

interface UsePrettifyPrice {
  prettifyPrice(price: number | string | Decimal, decimalPlaces?: number): string;
}

export function usePrettifyPrice(): UsePrettifyPrice {
  const { symbol } = useOwnedAccountCurrency();

  return useMemo(
    (): UsePrettifyPrice => ({
      prettifyPrice: prettifyPriceWithCurrencySymbol(symbol),
    }),
    [symbol],
  );
}
